export const categories = [
  {
    slug: 'xuanhuan',
    name: '玄幻',
    description: '东方玄幻世界，修炼成仙，逆天改命',
    comicCount: 1520,
    icon: 'ri-magic-line',
  },
  {
    slug: 'rexue',
    name: '热血',
    description: '燃爆的战斗场面，激荡人心的冒险旅程',
    comicCount: 980,
    icon: 'ri-fire-line',
  },
  {
    slug: 'lianai',
    name: '恋爱',
    description: '甜蜜浪漫的爱情故事，心动不已的青春物语',
    comicCount: 860,
    icon: 'ri-heart-line',
  },
  {
    slug: 'wuxia',
    name: '武侠',
    description: '快意恩仇的江湖世界，侠之大者为国为民',
    comicCount: 720,
    icon: 'ri-sword-line',
  },
  {
    slug: 'kehuan',
    name: '科幻',
    description: '探索未来科技与宇宙奥秘的想象之旅',
    comicCount: 540,
    icon: 'ri-rocket-line',
  },
  {
    slug: 'qihuan',
    name: '奇幻',
    description: '魔法与异世界的奇妙冒险，想象力无边界',
    comicCount: 650,
    icon: 'ri-moon-line',
  },
  {
    slug: 'lishi',
    name: '历史',
    description: '穿梭时空，见证历史的波澜壮阔',
    comicCount: 430,
    icon: 'ri-history-line',
  },
  {
    slug: 'jingji',
    name: '竞技',
    description: '热血竞技，追逐梦想的青春舞台',
    comicCount: 380,
    icon: 'ri-trophy-line',
  },
  {
    slug: 'gufeng',
    name: '古风',
    description: '唯美古风韵味，水墨丹青般的诗意世界',
    comicCount: 510,
    icon: 'ri-brush-line',
  },
  {
    slug: 'xuanyi',
    name: '悬疑',
    description: '扑朔迷离的故事，烧脑刺激的解谜体验',
    comicCount: 290,
    icon: 'ri-search-eye-line',
  },
];